import { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import SelectDropdown from '@/components/common/SelectDropdown';

import styles from './QuantitySelectorWB.module.scss';

export const QuantitySelectorWB = ({ isOutOfStock, size, setQuantity, className }) => {
  const [selectedValue, setSelectedValue] = useState({});
  const [classSelect, setClassSelect] = useState(className);

  const handleChange = (data) => {
    setSelectedValue(data);
    setQuantity(data.value);
  };

  const options = useMemo(() => {
    if (!isOutOfStock && size > 0) {
      return Array(size).fill(1).map((_, i) => ({ value: i + 1, label: i + 1 }));
    } else {
      return [{ value: 0, label: '' }];
    }
  }, [size]);

  useEffect(() => {
    if (isOutOfStock || size === 0) {
      setClassSelect(`${className} ${styles['select-hidden']}`);
    } else {
      setClassSelect(className);
      setQuantity(options[0].value);
      setSelectedValue(options[0]);
    }
  }, [isOutOfStock, size]);

  return (
    <SelectDropdown
      id="product-card-cp"
      options={options}
      selected={selectedValue}
      onChange={handleChange}
      className={classSelect}
    />
  );
};

QuantitySelectorWB.propTypes = {
  isOutOfStock: PropTypes.bool,
  size: PropTypes.number,
  setQuantity: PropTypes.func,
  className: PropTypes.string
};

export default QuantitySelectorWB;
